export class TabUsersEnableIN {
}
